module.exports = __webpack_public_path__ + "img/mailing.c0d9f4f7.png";